import { render, staticRenderFns } from "./CustomAudio.vue?vue&type=template&id=86d1a2be"
import script from "./CustomAudio.vue?vue&type=script&lang=js"
export * from "./CustomAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports